module.exports = __webpack_public_path__ + "static/media/platinum.f0cee539.webp";